import { Box } from "@mui/material";

export function Home(): JSX.Element {
  return (
    <Box px={5} py={4}>
      <div id="candu-page"></div>
    </Box>
  );
}
